import { getCategories } from "./config";

export default class BlockProvider {

    constructor() {
        this.categories = getCategories()
        this.reloadBlockConfig()
    }

    reloadBlockConfig() {
        // create toolboxCategories
        let newToolbox = {
            kind: "categoryToolbox",
            contents: []
        }
        this.categories.forEach(category => {
            // init category
            let categoryData = {
                kind: "category",
                name: category.name,
                colour: category.color,
                contents: []
            }
            // add blocks to category
            category.blocks.forEach(block => {

                let blockData = {
                    kind: "block",
                    type: block.name,
                    inputs: block.predefinedInputs
                }
                categoryData.contents.push(blockData)
            });
            // add category to toolbox
            newToolbox.contents.push(categoryData)
        });
        this.toolboxCategories = newToolbox
    }

    getToolboxCategories() {
        return this.toolboxCategories
    }

    prepareBlockly() {
        this.categories.forEach(category => {
            category.blocks.forEach(block => {
                block.addToBlockly()
            });
        });
    }
}
